import React from "react";

const NotFound = () => {
  return (
    <div className="flex justify-center align-middle my-5">
      <img
        className="w-full h-96 object-contain"
        src="https://www.pngitem.com/pimgs/m/254-2549834_404-page-not-found-404-not-found-png.png"
        alt="notFound"
      />
    </div>
  );
};

export default NotFound;
